import axios from "axios";

export const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
});

const mensagemTokenInvalido = "Token inválido ou expirado";

api.interceptors.response.use(
	(response) => response,
	async (error) => {
		const { status } = error.response;

		if (status === 401 && error.response.data === mensagemTokenInvalido) {
			localStorage.removeItem("dadosFilial");
			localStorage.removeItem("token");
			localStorage.removeItem("usuario");
			localStorage.removeItem("expiracao");
			localStorage.removeItem("Cookies");
			localStorage.removeItem("flagPassword");
			localStorage.removeItem("expirateTime");
			localStorage.removeItem("contextoEmbarque");
			localStorage.removeItem("notificacaoId");
			window.location.replace("login");
		}
		return Promise.reject(error);
	}
);
